module.exports = __webpack_public_path__ + "b42c5675ad55db86cc206e31a95d3a27.pdf";